import PropTypes from "prop-types";
import { fetchMyAcademics } from "data/actions/myAcademicsActions";
import { dispatchSlice } from "components/hooks/dispatchSlice";

export default function WithMyAcademics({ children }) {
  dispatchSlice(fetchMyAcademics);

  return children;
}

WithMyAcademics.propTypes = {
  children: PropTypes.node,
};
